<section class="toggle-form" [ngClass]="{ active: isDocumentSliderOpen }">
  <div class="formwrap">
    <div>
      <p-button
      appPreventDoubleClick
        styleClass="p-button-text"
        id="documentSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>
    <div class="general-container">
      <p-tabView [(activeIndex)]="activeTab"  (onChange)="onTabChange($event)">
        <p-tabPanel *ngIf="!isGlobalDocument && !isInternalClientContactLimitedAccess"
          header="General"
          [disabled]="!isDocumentEditSlider || !otherTabsEnabled"
          [rightIcon]="errorIconClassForTab"
        >
          <div class="content">
            <app-document-general-details
              (activateTabIndex)="openCurrentTab($event)"
              (enableOtherTabs)="onEnableOtherTabs($event)"
              ></app-document-general-details>
          </div>
        </p-tabPanel>
        <p-tabPanel
          header="Files"
          [disabled]="!isDocumentEditSlider || !otherTabsEnabled"
          [rightIcon]="errorIconClassForFilesTab"
        >
          <app-document-files
            *ngIf="showFilesTab"
            (activateTabIndex)="openCurrentTab($event)"
            (enableOtherTabs)="onEnableOtherTabs($event)"
            [isDocumentFileCheckedOut]="isFileCheckedOut"
            [isGlobalDocument]="isGlobalDocument"
            [isInternalClientContactLimitedAccess]="isInternalClientContactLimitedAccess"
          ></app-document-files>
        </p-tabPanel>
        <p-tabPanel *ngIf="!isInternalClientContactLimitedAccess"
          header="Related Documents"
          [disabled]="!isDocumentEditSlider || !otherTabsEnabled"
        >
        <app-document-related-documents (activateTabIndex)="openCurrentTab($event)" (enableOtherTabs)="onEnableOtherTabs($event)" [isGlobalDocument]="isGlobalDocument" [relatedDocuments]="relatedDocuments"
        >
        </app-document-related-documents>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</section>
